import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import {
  ShareVehicleByVehicleDto,
  VehicleTableDto,
  VehicleTableQuery,
} from '../../../models/vehicle/vehicle-list.model';

@Injectable({
  providedIn: 'root',
})
export class ApiVehicleListService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  getVehicleForTable(query: VehicleTableQuery): Observable<VehicleTableDto> {
    const token = this.cookieService.get('token');
    const params: Record<string, string | number> = {
      page: query.page ?? 1,
      pageSize: query.pageSize ?? 20,
    };

    if (query.searchText?.trim()) {
      params['searchText'] = query.searchText.trim();
    }

    return this.apiMethodService.request<VehicleTableDto>(
      '/backoffice/getVehicleForTable',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getVehicleForTable',
        token,
        headerOnly: false,
        params,
      }
    );
  }

  getShareVehicleByVehicleId(
    vehicleId: number,
  ): Observable<ShareVehicleByVehicleDto> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ShareVehicleByVehicleDto>(
      '/backoffice/getShareVehicleByVehicleId',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'getShareVehicleByVehicleId',
        token,
        headerOnly: false,
        params: { vehicleId },
      }
    );
  }
}
